import { h } from 'preact';

export default props => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M4 6L8 10L12 6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);